<template>
    <nav
        ref="navbar"
        class="navbar navigation-background border-bottom py-0"
    >
        <div
            class="d-flex align-items-center justify-content-between w-100 flex-nowrap text-nowrap"
        >
            <router-link
                v-if="$route.path !== '/'"
                :to="{ name: '/' }"
                class="navbar-brand p-0 nav-link p-0 m-0 ms-2"
            >
                <img
                    :src="logoUrl"
                    height="45"
                />
            </router-link>
            <a
                v-else
                class="navbar-brand p-0 nav-link p-0 m-0 ms-2"
                href="/"
            >
                <img
                    :src="logoUrl"
                    height="45"
                />
            </a>

            <span
                v-if="appStore.env.enviroment !== 'production'"
                class="badge rounded-pill text-bg-cyan text-white p-2 border ms-2"
                >Env: {{ appStore.env.enviroment }}</span
            >

            <span
                v-if="userStore.adminOverrideEnabled"
                class="badge rounded-pill text-bg-bordeaux text-white p-2 border ms-2"
                >Admin override actief</span
            >

            <nav
                ref="breadcrumb"
                aria-label="breadcrumb me-auto"
            >
                <ol class="breadcrumb m-0 flex-nowrap text-nowrap">
                    <li class="breadcrumb-item"></li>
                    <li
                        v-for="breadcrumb in breadcrumbs"
                        :key="breadcrumb.id"
                        class="breadcrumb-item"
                    >
                        <router-link
                            v-if="breadcrumb.navigatable"
                            :to="breadcrumb.route"
                            class=""
                        >
                            {{ breadcrumb.label }}
                        </router-link>
                        <span v-else>{{ breadcrumb.label }}</span>
                    </li>
                    <li
                        class="breadcrumb-item active"
                        aria-current="page"
                    >
                        {{ $route.meta.label }}
                    </li>
                </ol>
            </nav>

            <ul class="navbar-nav ms-auto flex-row align-items-center">
                <li class="nav-item mx-2">
                    <BroadcastIndicator />
                </li>

                <li
                    v-if="false"
                    class="nav-item mx-2"
                >
                    <a class="nav-link">
                        <i class="fa-solid fa-magnifying-glass fa-xl"></i>
                    </a>
                </li>

                <li
                    v-if="false"
                    class="nav-item mx-2"
                >
                    <a class="nav-link">
                        <i class="fa-regular fa-bell fa-xl"></i>
                    </a>
                </li>

                <li class="nav-item mx-2 dropdown me-2">
                    <a
                        class="nav-link no-after"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <div class="d-flex">
                            <UserIcon
                                :name="userStore.getFullname"
                                :rounded="true"
                                class="me-2"
                            />
                            <div ref="username">
                                <div class="fw-bold">
                                    {{ userStore.getFullname }}
                                </div>
                                <div class="text-muted lh-1">
                                    {{ userStore.getCompanyName }}
                                </div>
                            </div>
                        </div>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end position-absolute">
                        <li v-if="showCustomerSwitch">
                            <h6 class="dropdown-header">Wissel van bedrijf</h6>
                        </li>
                        <li
                            v-if="userStore.isEmployee && customerOptionsAvailable"
                            class="dropdown-item"
                            @click="setActiveCustomer(null)"
                        >
                            {{ ENV.entityname }}
                        </li>
                        <li
                            v-for="customer in userStore.customers"
                            v-if="showCustomerSwitch"
                            :key="customer.id"
                            class="dropdown-item"
                            @click="setActiveCustomer(customer.id)"
                        >
                            {{ customer.name }}
                        </li>

                        <li v-if="showCustomerSwitch">
                            <hr class="dropdown-divider" />
                        </li>

                        <li>
                            <h6 class="dropdown-header">Mijn account</h6>
                        </li>
                        <li>
                            <router-link
                                :to="{ name: '/auth/account' }"
                                class="dropdown-item"
                                :class="{
                                    active: $route.name == '/auth/account',
                                }"
                            >
                                Instellingen
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{ name: '/auth/logout', query: { manual: true } }"
                                class="dropdown-item"
                            >
                                Uitloggen
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style>
.avatar {
    height: 45px;
    width: 45px;
}

.no-after::after {
    display: none;
}
</style>

<script>
import BroadcastIndicator from "@components/BroadcastIndicator.vue";
import UserIcon from "@components/UserIcon.vue";
import eventbus from "@eventbus";
import { getStorage } from "@helpers/storage";
import { router } from "@router/router";
import { useAppStore } from "@stores/appStore";
import { useUserStore } from "@stores/userStore.js";

export default {
    name: "AppHeader",
    components: { BroadcastIndicator, UserIcon },
    props: {
        theme: {
            type: String,
        },
    },
    setup() {
        const appStore = useAppStore();
        const userStore = useUserStore();
        return { appStore, userStore };
    },
    data() {
        return {
            breadcrumbNames: [],
            name: "",
        };
    },
    computed: {
        breadcrumbs() {
            const data = [];
            const includesAll = (arr, values) => values.every((v) => arr.includes(v));
            this.breadcrumbNames.forEach((name) => {
                const route = this.$router.resolve({ name: name }, this.$route);
                const needed_params = Object.keys(route.params);
                const available_params = Object.keys(this.$route.params);
                const breadcrumb = {
                    id: data.length + 1,
                    label: route.meta.label,
                    navigatable: includesAll(available_params, needed_params),
                    route: route,
                };
                data.push(breadcrumb);
            });
            return data;
        },
        customerOptionsAvailable() {
            if (this.userStore.customers === null) {
                return false;
            }

            if (this.userStore.customers.length === 0) {
                return false;
            }

            return true;
        },
        showCustomerSwitch() {
            if (
                this.userStore.isEmployee &&
                this.userStore.customers &&
                this.userStore.customers.length > 0
            ) {
                return true;
            }

            if (
                !this.userStore.isEmployee &&
                this.userStore.customers &&
                this.userStore.customers.length > 1
            ) {
                return true;
            }

            return false;
        },
        logoUrl() {
            const themePrefix = this.appStore.getTheme === "dark" ? "-dark" : "";
            const url = `/branding/${this.ENV.brandname}/logo${themePrefix}.svg`;
            return url;
        },
    },
    watch: {
        breadcrumbs() {
            this.$nextTick(this.checkNavbarOverflow);
        },
        items() {
            this.updateData();
        },
        userStore: {
            deep: true,
            handler() {
                this.$nextTick(this.checkNavbarOverflow);
            },
        },
    },
    mounted() {
        this.updateData();
        eventbus.on("breadcrumbs-set", this.setBreadcrumbs);
        window.addEventListener("resize", this.checkNavbarOverflow);
        this.checkNavbarOverflow(); // Initial check
    },
    unmounted() {
        eventbus.off("breadcrumbs-set", this.setBreadcrumbs);
        window.removeEventListener("resize", this.checkNavbarOverflow);
    },
    methods: {
        checkNavbarOverflow() {
            const navbar = this.$refs.navbar;
            const breadcrumbs = this.$refs.breadcrumb;
            const userInfo = this.$refs.username;

            // Reset
            breadcrumbs.classList.remove("d-none");
            userInfo.classList.remove("d-none");

            if (navbar.scrollWidth > navbar.clientWidth) {
                // Hide breadcrumbs if navbar is overflowing
                breadcrumbs.classList.add("d-none");

                // Check again after hiding breadcrumbs
                if (navbar.scrollWidth > navbar.clientWidth) {
                    // Hide username if still overflowing
                    userInfo.classList.add("d-none");
                }
            }
        },
        setActiveCustomer(id) {
            this.selectedCustomer = id;
            this.userStore.setActiveCustomerId(id);
            eventbus.emit("customer-switch");

            // Ensure that the user is redirected to the dashboard if they are on a page
            // that is not accessible to customers or employees
            // Employee
            if (this.userStore.isEmployee && this.userStore.selectedCustomerId === null) {
                if (this.$route.meta.customer_only) {
                    router.push("/");
                }
            }
            // Customer
            else {
                if (!this.$route.meta.customer_only || !this.$route.meta.customer_allowed) {
                    router.push("/");
                }
            }
        },
        setBreadcrumbs(breadcrumbs) {
            this.breadcrumbNames = breadcrumbs;
        },
        updateData() {
            this.name = getStorage("name");
        },
    },
};
</script>
